import Vue from 'vue'

import AppLayout from './layout/index.vue'
import router from './router'
import store from './store'

import './mixins'
import './plugins'
import './thirdParty'

import './scss/style.scss'
import './assets/fonts/bebasneue.css'
import 'vue-toast-notification/dist/theme-default.css'
import './service-worker'
import JsonExcel from 'vue-json-excel'
import i18n from './i18n'
import frag from 'vue-frag'
import HighchartsVue from 'highcharts-vue'

Vue.component('downloadExcel', JsonExcel)
Vue.directive('frag', frag)
Vue.use(HighchartsVue)
Vue.config.productionTip = false

new Vue({
  name: 'Root',
  router,
  store,
  i18n,
  methods: {
    updateFavicon(newPath) {
      document.querySelectorAll('link[rel~="icon"]').forEach((e) => e.remove())
      const link = document.createElement('link')
      link.rel = 'icon'
      link.href = `${newPath}?v=${Date.now()}`
      document.getElementsByTagName('head')[0].appendChild(link)
    },
    handleSetConfig() {
      // @TODO: load config from api fix for shopsavvy
      const domain = window.location.hostname
      let primaryColor = '#11b4a8'
      let primaryBoldColor = '#113158' // default
      const defaultSetting = {
        logoUrl: '/pos_logo.png',
        authLogoUrl: '/new_logo_resized.png'
      }
      switch (domain) {
        case 'daily.shopsavvypos.com': {
          primaryColor = '#235393'
          primaryBoldColor = '#132136'
          store.commit('common/SET_SETTING_CONFIG', { logoUrl: '/ShopSavvyLogo.png', authLogoUrl: '/ShopSavvyLogo.png' })
          this.updateFavicon('/savvy_icon.png')
          break
        }

        default:
          store.commit('common/SET_SETTING_CONFIG', defaultSetting)
          break
      }
      document.documentElement.style.setProperty('--primary-color', primaryColor)
      document.documentElement.style.setProperty('--primary-bold-color', primaryBoldColor)
    }
  },
  mounted() {
    this.handleSetConfig()
    store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth)
    window.addEventListener('resize', () => store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth))
  },

  beforeDestroy() {
    window.removeEventListener('resize', () => store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth))
  },
  render: (h) => h(AppLayout)
}).$mount('#app')
